import { evaluate } from "mathjs";
import { TOKEN_DECIMALS } from "../constants/tokens";

const formatDecimal = (number: number) => evaluate(number / TOKEN_DECIMALS);
const formatDecimalFromSun = (number: number) => evaluate(number / 1000000);

const formatPrice = (number) =>
  new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 8,
    maximumFractionDigits: 8,
  }).format(number);

const formatLocal = (number) =>
  new Intl.NumberFormat(undefined, { maximumSignificantDigits: 3 }).format(
    number
  );

const formatLocalBalance = (number) =>
  new Intl.NumberFormat(undefined, { maximumSignificantDigits: 8 }).format(
    number
  );

const divide = (n: number, d: number) => evaluate(n / d);
const multiply = (n1: number, n2: number) => evaluate(n1 * n2);

const formatAbbr = (n) => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "k";
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
};

export {
  formatDecimal,
  formatPrice,
  formatLocal,
  formatDecimalFromSun,
  divide,
  multiply,
  formatAbbr,
  formatLocalBalance,
};
